import { render, staticRenderFns } from "./PostAdd.vue?vue&type=template&id=60755d8a&scoped=true&"
import script from "./PostAdd.vue?vue&type=script&lang=js&"
export * from "./PostAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60755d8a",
  null
  
)

export default component.exports